export enum LabelPosition {
  TOP = 'top',
  LEFT = 'left'
}
